export default {
    listagem: {
        titulo_pagina: 'List of Exams',
        novo: 'Create New Exam',
        habilitado: 'Able',
        desabilitado: 'Disabled',
        table: {
            empty: 'No Exam Found',
            codigo: 'Code',
            nome: 'Name',
            mnemonico: 'Mnemonic',
            componente: 'Component',
            metodo: 'Method',
            escala: 'Scale',
            material: 'Material',
            tempo: 'Time',
            editar: 'Edit'
        },
        bulk: {
            inserir: 'Bulk Insert',
            desselecionar: 'Unable to craft with selected items!',
            selecione_um_item: 'Select at least 1 item from the list!',
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Exam',
            editar: 'Edit Exam'
        },
        fieldsets: {
            informacoes: 'Information',
            composicao: 'Composition',
            metodo: 'Method',
            materiais_possiveis: 'Possible Specimens',
            mnemonicos: 'Mnemonics Veus',
            sub_exames: 'Sub Exams',
            sinonimos: 'Synonyms',
            loinc: 'LOINC',
            bypass: 'Mapping Bypass',
            compound: 'Composite Exam'
        },
        fields: {
            adicionar_subexames: 'Add Sub Exams',
            adicionar_sinonimos: 'Add Synonyms',
            adicionar_metodo: 'Add Method',
            status: {
                label: 'Status',
                description: 'Exam active or inactive status'
            },
            ordem_resultado: {
                label: 'Order / Result',
                description: 'Exam Type'
            },
            nome: {
                label: 'Name',
                description: 'Exam Name'
            },
            codigo: {
                label: 'Code',
                description: 'Exam Code'
            },
            componente: {
                label: 'Component',
                description: 'Exam Component'
            },
            material: {
                label: 'Material',
                description: 'Exam Material'
            },
            metodo: {
                label: 'Method',
                description: 'Exam Method',
                warning: {
                    duplicated: 'The selected method has already been added!'
                }
            },
            possible_specimens: {
                label: 'Possible Specimens',
                integration_label: 'Support integration',
                integration_unavailable: 'Integration unavailable',
                material_label: 'Possible specimen',
                material_placeholder: 'Enter the possible specimen',
                adicionar: 'Add possible specimen',
                warning: {
                    incomplete: 'Fill in the support integration and the possible specimen on all rows.',
                    duplicated: 'This support integration has already been added. Only one possible specimen per exam is allowed for each support integration.'
                }
            },
            tempo: {
                label: 'Time',
                description: 'Exam Time'
            },
            escala: {
                label: 'Scale',
                description: 'Exam Scale'
            },
            mnemonico_veus_exam: {
                label: 'Mnemonic Veus Exam',
                description: 'Mnemonic Exam'
            },
            mnemonico_veus_subexam: {
                label: 'Mnemonic Veus Sub Exam',
                description: 'Mnemonico Sub Exam'
            },
            adicionar_sub_exame_form: {
                label: 'Add Sub-exam'
            },
            adicionar_sinonimos_form: {
                label: 'Add Synonyms'
            },
            specimen_complement: {
                label: 'Specimen Complement',
                description: 'Enable or disable specimen complement bypass'
            },
            directions: {
                ordem: 'Order',
                resultado: 'Observation',
                ambos: 'Both'
            },
            compound: {
                label: 'Composite Exam',
                description: 'Indicate whether the parent exam in the hierarchy is a compound exam'
            },
            botao_salvar : 'Save Exam'
        },
        create: {
            success: 'Exam successfully created!',
            error: 'Error creating Exam!'
        },
        update: {
            success: 'Successfully edited exam!',
            error: 'Error editing Exam!'
        }
    }
}
